/**
 * @generated SignedSource<<b7cfd1c0801a136e4d546f2d63cebfe0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSearchResults_results$data = {
  readonly flights: ReadonlyArray<{
    readonly priceKey: string;
    readonly " $fragmentSpreads": FragmentRefs<"FlightSearchResult_flight">;
  }>;
  readonly " $fragmentType": "FlightSearchResults_results";
};
export type FlightSearchResults_results$key = {
  readonly " $data"?: FlightSearchResults_results$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSearchResults_results">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightSearchResults_results",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FlightJson",
      "kind": "LinkedField",
      "name": "flights",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceKey",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightSearchResult_flight"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FlightSearchResult",
  "abstractKey": null
};

(node as any).hash = "16a12b16be654c8b5fc14442288f9964";

export default node;
